import { render, staticRenderFns } from "./VErro.vue?vue&type=template&id=fddf861c"
import script from "./VErro.vue?vue&type=script&lang=js"
export * from "./VErro.vue?vue&type=script&lang=js"
import style0 from "./VErro.vue?vue&type=style&index=0&id=fddf861c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports